const STORAGE_KEY = 'mobile-browsing-history';
const MAX_ITEMS = 50;

const normalizeSnapshot = (product) => {
  if (!product || product.id == null) return null;
  const images = product.images;
  let image = product.image || null;
  if (!image && Array.isArray(images) && images.length) image = images[0];
  if (!image && typeof images === 'string') {
    try {
      const parsed = JSON.parse(images);
      if (Array.isArray(parsed) && parsed[0]) image = parsed[0];
    } catch (_) {
      /* ignore */
    }
  }
  const seller = product.seller || product.user || {};
  return {
    id: product.id,
    name: product.name || product.title || 'Product',
    image,
    priceMin: product.priceMin ?? product.price ?? null,
    priceMax: product.priceMax ?? null,
    moq: product.moq || product.minOrderQty || null,
    soldCount: product.soldCount ?? product.sold ?? null,
    category: product.category || '',
    seller: {
      country: seller.country || 'CN',
      yearsActive: seller.memberYears || seller.yearsInBusiness || seller.yearsActive || null,
    },
    viewedAt: Date.now(),
  };
};

export function appendMobileBrowsingProduct(product) {
  const snap = normalizeSnapshot(product);
  if (!snap) return;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    let list = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(list)) list = [];
    list = list.filter((x) => String(x.id) !== String(snap.id));
    list.unshift(snap);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
  } catch (_) {
    /* ignore */
  }
}

export function readMobileBrowsingHistory() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch (_) {
    return [];
  }
}
